// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { IConsultarRelatorioMensalDareRequest, Types } from './types';

export function consultarRelatorioMensalDareRequest(
	token: string,
	payload: IConsultarRelatorioMensalDareRequest,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_RELATORIO_MENSAL_DARE_REQUEST,
		token,
		payload,
	};
}

export function consultarRelatorioMensalDareSuccess(
	payload: object,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_RELATORIO_MENSAL_DARE_SUCCESS,
		payload,
	};
}

export function consultarRelatorioMensalDareFailure(): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_RELATORIO_MENSAL_DARE_FAILURE,
		payload: null,
	};
}

export function consultarRelatorioMensalDareClear(): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_RELATORIO_MENSAL_DARE_CLEAR,
		payload: null,
	};
}
